import { render, staticRenderFns } from "./dialog-alerteditonline.vue?vue&type=template&id=143d2d72&"
import script from "./dialog-alerteditonline.vue?vue&type=script&lang=js&"
export * from "./dialog-alerteditonline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports